import "../styles/Navbar.css";
import { useState } from "react";
import { getUserData } from "../utils/authStorage";
import api, { updateMessage210, updateNacType } from "../api/api"; // import your axios instance

const Navbar = ({ title }) => {
  const [nacType, setNacType] = useState("production"); // production / test
  const [msg210, setMsg210] = useState("static"); // static / dynamic

  const userData = getUserData();
  const user = userData?.user || userData || {};
  const userType = user.user_type;

  // Function to update NAC type on backend
  const handleNacTypeChange = async () => {
    const newValue = nacType === "production" ? "test" : "production";
    setNacType(newValue); // optimistic UI update

    try {
      const data = await updateNacType(newValue);
      console.log("data", data, data.token);
      if (data.isSuccess) {
        setNacType(data.nacType);
      }
    } catch (err) {
      console.error("Failed to update NAC type:", err);
      setNacType(nacType); // revert on error
    }
  };

  // Function to update Message 210 on backend
  const handleMsg210Change = async () => {
    const newValue = msg210 === "dynamic" ? "static" : "dynamic";
    setMsg210(newValue); // optimistic UI update

   try {
      const data = await updateMessage210(newValue);
      console.log("data", data, data.token);
      if (data.isSuccess) {
        setMsg210(data.message210);
      }
    } catch (err) {
      console.error("Failed to update NAC type:", err);
      setMsg210(nacType); // revert on error
    }
  };

  return (
    <nav className="navbar">
      <h1 className="navbar-title">{title}</h1>

      {userType === "admin" && (
        <div className="switch-container">
          {/* NAC TYPE SWITCH */}
          {/* <div className="switch-group">
            <span className="switch-label-left">NAC Type</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={nacType === "production"}
                onChange={handleNacTypeChange}
              />
              <span className="slider"></span>
            </label>
            <span className="switch-label-right">
              {nacType === "production" ? "Production" : "Test"}
            </span>
          </div> */}

          {/* MESSAGE 210 SWITCH */}
          {/* <div className="switch-group">
            <span className="switch-label-left">210 Message</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={msg210 === "dynamic"}
                onChange={handleMsg210Change}
              />
              <span className="slider"></span>
            </label>
            <span className="switch-label-right">
              {msg210 === "dynamic" ? "Dynamic" : "Static"}
            </span>
          </div> */}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
